import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router";

import { HELP_LINE_KEY_TEMPLATE } from "@/constants/HelpUrls";
import MasterDetail from "@/design/layouts/MasterDetail";
import { setHelpUrl } from "@/store/reducers/ui";

import { useHotkey } from "@tanstack/react-hotkeys";

import LineKeyTemplate from "./LineKeyTemplate";
import LineKeyTemplateList from "./LineKeyTemplateList";

export default function LineKeyTemplates() {
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(setHelpUrl(HELP_LINE_KEY_TEMPLATE));
  }, [dispatch]);

  useHotkey("Alt+N", () => navigate(`/pbx/${params.pbxId}/settings/line-key-templates/new`));

  return <MasterDetail identifier="id" master={<LineKeyTemplateList />} detail={<LineKeyTemplate />} />;
}
